import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales'; // 'moment/min/moment-with-locales';
import { Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { shortDateFormat } from '~/utils/dateFormat';

class AbsencesTotals extends Component {
    constructor(props) {
        super(props)
        this.state = {
            for_date: props.for_date ? moment(props.for_date) : moment(),
            to_date: props.to_date ? moment(props.to_date) : moment(),
            user_id: props.user_id ? props.user_id : null,
            absenceStatus: props.absenceStatus ? props.absenceStatus : null,
            data: null,
            isLoading: true,
            loadedUser: null,
        }
    }

    async loadData() {
        try {
            const { user_id, for_date, to_date } = this.state;
            const userId = user_id ? user_id : this.props.userStore?.currentUser?.id;
            const params = {
                user_id: userId,
                from: moment(for_date).format('YYYY-MM-DD'),
                to: moment(to_date).format('YYYY-MM-DD'),
                editAbsenceId: this.props.edit_absence_id ? this.props.edit_absence_id : 0,
            }

            const result = await this.props.absenceStore.getAbsenceTotals(params);
            const _loadedUser = !user_id ? this.props.userStore?.currentUser : await this.props.userStore.pullUserById(userId);
            this.setState({ user_id: userId, data: result, loadedUser: _loadedUser, isLoading: false }, () => {
                if (this.props.forceReloadForm) this.props.forceReloadForm();
            });
        } catch (err) {
            console.error(err);
            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
        }
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        const { t, commonStore, userStore } = this.props;
        const { isLoading, for_date, absenceStatus, data, loadedUser } = this.state;
        if (isLoading) return <LoadingSpinner />;

        const dateTimeRules = commonStore.getDateTimeRules();
        const { IASickLeavesEnabled, allowCollectiveAgreementLeave, allowSocialWelfareLeave } = commonStore.config?.client?.data?.basicRules;

        const { selfClearances, totalSelfClearances, childDays, childDaysUsed, cycleEndDate, cycleStartDate, employee_percent, firstLeaveInCycle,
            totalCollectiveAgreementDays, collectiveAgreementUsed, totalSocialWelfareLeaveHours, socialWelfareLeaveHoursUsed } = data;
        const _nextSickLeaveCycleStartDate = moment(firstLeaveInCycle).add(1, 'year').add(1, 'day').format(dateTimeRules.short_date_format);
        const showParentalLeaves = parseInt(childDays) > 0;
        const sickLeaveTitle = !IASickLeavesEnabled ? 'Self Clarification' : 'IA Sick Leave';
        const currentUserType = userStore?.currentUser?.user_type;

        if (!loadedUser)
            return <LoadingSpinner />;

        return (
            <Row className="mb-4 align-items-center">
                <Col md={12} className={'mt-2'}>
                    <Row>
                        <Col xs={6} sm={4} md={1} className={'mt-2'}>
                            <div className="vacation-panel__item vacation-panel__divider" >
                                <span className="vacation-panel__value">{for_date.year()}</span>
                                <span title={t('Year')} className="vacation-panel__label">{t('Year')}</span>
                            </div>
                        </Col>
                        {cycleEndDate &&
                            <Col xs={6} sm={4} md={3} className={'mt-2'}>
                                <div className="vacation-panel__item vacation-panel__divider" >
                                    <span className="vacation-panel__value_small">{shortDateFormat(cycleStartDate, dateTimeRules)}</span>
                                    <span className="vacation-panel__value_small">{shortDateFormat(cycleEndDate, dateTimeRules)}</span>
                                    <span title={t('Year')} className="vacation-panel__label">{t('Sick Leave Cycle')}</span>
                                </div>
                            </Col>
                        }
                        <Col xs={6} sm={4} md={1} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">{employee_percent}%</span>
                                <span title={t('Employment')} className="vacation-panel__label">{t('Employment')}</span>
                            </div>
                        </Col>
                        <Col xs={6} sm={4} md={2} className={'mt-2'}>
                            <div className="vacation-panel__item">
                                <span className="vacation-panel__value">
                                    {selfClearances}&nbsp;
                                    {t('of')}&nbsp;{totalSelfClearances}
                                    {parseInt(selfClearances) === totalSelfClearances &&
                                        <OverlayTrigger
                                            key="top"
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t("You have used up all the allowed sick-leaves in the current cycle. A new sick-leave will be available from")}:&nbsp;
                                                    {_nextSickLeaveCycleStartDate}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    }
                                </span>
                                <span title={t(sickLeaveTitle)} className="vacation-panel__label vacation-panel__gradient_underline">{t(sickLeaveTitle)}</span>
                            </div>
                        </Col>
                        {showParentalLeaves &&
                            <Col xs={6} sm={4} md={2} className={'mt-2'}>
                                <div className="vacation-panel__item">
                                    <span className="vacation-panel__value">
                                        {childDaysUsed} {t('of')} {childDays}
                                    </span>
                                    <span title={t('Child sickness')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Child sickness')}</span>
                                </div>
                            </Col>
                        }
                        {allowCollectiveAgreementLeave &&
                            <Col xs={6} sm={4} md={2} className={'mt-2'}>
                                <div className="vacation-panel__item">
                                    <span className="vacation-panel__value">
                                        {collectiveAgreementUsed} {t('of')} {totalCollectiveAgreementDays}
                                    </span>
                                    <span title={t('Collective Agreement')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Collective Agreement')}</span>
                                </div>
                            </Col>
                        }
                        {allowSocialWelfareLeave && currentUserType !== 'member' &&
                            <Col xs={6} sm={4} md={2} className={'mt-2'}>
                                <div className="vacation-panel__item">
                                    <span className="vacation-panel__value">
                                        {socialWelfareLeaveHoursUsed} {t('of')} {totalSocialWelfareLeaveHours} {t('hr')}
                                    </span>
                                    <span title={t('Social Welfare')} className="vacation-panel__label vacation-panel__gradient_underline">{t('Social Welfare')}</span>
                                </div>
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>
        );
    }
}

export default inject('absenceStore', 'userStore', 'commonStore')(withLocalization(observer(AbsencesTotals)));
